import { FC, useState } from 'react'
import { OrderList } from 'primereact/orderlist'

interface PillarsProps {
    initPillars: any
    setSectionsOrder: any
}
const Pillars: FC<PillarsProps> = ({ initPillars = [], setSectionsOrder }) => {
    const [pillars, setPillars] = useState(initPillars)

    const itemTemplate = (item) => {
        return (
            <>
                <div className="row">
                    <div className="col-md-8 mt-4">
                        <div className="">
                            <div
                                className="content p-4 mb-0"
                                style={{ direction: 'ltr' }}
                            />
                        </div>
                        <div
                            className=""
                            dangerouslySetInnerHTML={{
                                __html: item.value || '',
                            }}
                        ></div>
                    </div>
                    <div className="col-md-4 pl-lg-0 mt-4">
                        <div className="">
                            <div
                                className="content p-4 page-section-img-container  mb-20"
                                style={{ minHeight: '100px' }}
                            >
                                {item.img_url && (
                                    <img
                                        alt={item.name}
                                        src={item.img_url}
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100px',
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <OrderList
            dataKey="id"
            value={pillars}
            onChange={(e) => {
                for (const i in e.value) {
                    setSectionsOrder((prevState) => {
                        return {
                            ...prevState,
                            [e.value[i].id]: parseInt(i) + 1,
                        }
                    })
                }

                setPillars(e.value)
            }}
            itemTemplate={itemTemplate}
            header=""
            dragdrop
            listStyle={{
                minHeight: 580,
            }}
            onDragEnterCapture={(t) => {
                const _tar = t.currentTarget.classList.contains(
                    'p-orderlist-droppoint'
                )
                console.log(_tar)
                // console.log(t.currentTarget.classList)
            }}
        ></OrderList>
    )
}

export default Pillars
